import { computed } from 'vue';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';
import { useModalStore } from '@/stores/components/modalStore';
import { useGlobalStore } from '@/stores/globalStore';

export default () => {
  const orderStore = useOrderFormStore();
  const modalStore = useModalStore();
  const globalStore = useGlobalStore();

  /**
   * Check if the current order has USDT coin and EUR fiat currency
   * @returns {boolean} True if USDT/EUR combination is detected
   */
  const isUsdtEurCombination = computed(() => {
    const coinType = orderStore.getCoinType;
    const fiatType = orderStore.getFiatType;

    return coinType === 'USDT' && fiatType === 'EUR';
  });

  /**
   * Show the USDT/EUR restriction modal
   * @param {Function} onContinue - Callback when user chooses to continue with USDT
   * @param {Function} onSelectAnother - Callback when user chooses to select another coin
   */
  const showUsdtEurRestrictionModal = (onContinue = null, onSelectAnother = null) => {
    const { options } = modalStore.usdtEurRestrictionModal;
    options.primaryBtnAction = onContinue;
    options.secondaryBtnAction = () => {
      onSelectAnother?.();
      const { returnUrl } = globalStore.global?.merchant || {};
      if (returnUrl) window.location.href = returnUrl;
    };
    modalStore.toggleUsdtEurRestrictionModal(true);
  };

  /**
   * Hide the USDT/EUR restriction modal
   */
  const hideUsdtEurRestrictionModal = () => {
    modalStore.toggleUsdtEurRestrictionModal(false);
  };

  /**
   * Check and show modal if USDT/EUR combination is detected
   * @param {Function} onContinue - Callback when user chooses to continue with USDT
   * @param {Function} onSelectAnother - Callback when user chooses to select another coin
   */
  const checkAndShowUsdtEurRestriction = (onContinue = null, onSelectAnother = null) => {
    if (isUsdtEurCombination.value) {
      showUsdtEurRestrictionModal(onContinue, onSelectAnother);
      return true;
    }
    return false;
  };

  return {
    isUsdtEurCombination,
    showUsdtEurRestrictionModal,
    hideUsdtEurRestrictionModal,
    checkAndShowUsdtEurRestriction,
  };
};
